import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d539749"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Employee Details\n          "),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", null, "\n            If you are unsure of any of the information below, please contact\n            your local HR advisor/manager in order to obtain the correct\n            information.\n          ")
], -1));
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = { class: "col-span-3" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Is the leaver a Contractor or Agency Temp? *\n            ", -1));
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "mt-4 space-y-4" };
const _hoisted_10 = { class: "flex items-start" };
const _hoisted_11 = { class: "h-5 flex items-center" };
const _hoisted_12 = ["disabled"];
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "is_temp_yes",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_14 = { class: "flex items-start" };
const _hoisted_15 = { class: "h-5 flex items-center" };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "is_temp_no",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_18 = { class: "col-span-6" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employee-name",
    class: "block text-sm font-medium text-gray-700"
}, "Employee's full name *", -1));
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_22 = { class: "col-span-6" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employee-name",
    class: "block text-sm font-medium text-gray-700"
}, "Employee Number *", -1));
const _hoisted_24 = ["disabled"];
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, " *Please enter the 6 digit employee number for the leaver. ")
], -1));
const _hoisted_26 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_27 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "division",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n              Division *\n            ", -1));
const _hoisted_29 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = ["value"];
const _hoisted_32 = ["value"];
const _hoisted_33 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_34 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "sector",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n              Sector *\n            ", -1));
const _hoisted_36 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_37 = ["disabled"];
const _hoisted_38 = ["value"];
const _hoisted_39 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_40 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "company_code",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n              Company Code *\n            ", -1));
const _hoisted_42 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_43 = ["disabled"];
const _hoisted_44 = ["value"];
const _hoisted_45 = ["value"];
const _hoisted_46 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_47 = { class: "col-span-6" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "personal-name",
    class: "block text-sm font-medium text-gray-700"
}, "Personal/home email address of the employee leaving:", -1));
const _hoisted_49 = ["disabled"];
const _hoisted_50 = { class: "col-span-6" };
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "location",
    class: "block text-sm font-medium text-gray-700"
}, "Work Location *", -1));
const _hoisted_52 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_53 = ["value", "disabled"];
const _hoisted_54 = ["value"];
const _hoisted_55 = ["value"];
const _hoisted_56 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_57 = { class: "col-span-6" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "location-postcode",
    class: "block text-sm font-medium text-gray-700"
}, "Work Location postcode", -1));
const _hoisted_59 = ["value"];
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "\n            *Please enter a personal / home email address for the employee. This\n            will be used to send them a confidential exit interview\n            questionnaire that they can complete anonymously. Ensure that the\n            employee knows that providing a personal email address is optional.\n            Please encourage completion of the questionnaire. £1 is paid to\n            Charity for every completed questionnaire. A copy of the\n            questionnaire is also available here.\n          ")
], -1));
const _hoisted_61 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_62 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.formData)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("fieldset", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(),
                            (_ctx.v$.formData.is_temp.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n              * " + _toDisplayString(_ctx.v$.formData.is_temp.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "radio-button-is_leaver",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formData.is_temp) = $event)),
                                            value: "Yes",
                                            name: "is_temp_yes",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                }]),
                                            disabled: _ctx.disableForm,
                                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.is_temp.$touch()))
                                        }, null, 42, _hoisted_12), [
                                            [_vModelRadio, _ctx.formData.is_temp]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_13
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "radio-button-it-leaver",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.is_temp) = $event)),
                                                value: "No",
                                                name: "is_temp_no",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                    }]),
                                                disabled: _ctx.disableForm,
                                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.is_temp.$touch()))
                                            }, null, 42, _hoisted_16), [
                                                [_vModelRadio, _ctx.formData.is_temp]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_17
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "name-input",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.employee_name) = $event)),
                                type: "text",
                                name: "employee-name",
                                autocomplete: "employee-name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'error-border': _ctx.v$.formData.employee_name.$error,
                                        'border-red-500': _ctx.v$.formData.employee_name.$error,
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.employee_name.$touch()))
                            }, null, 42, _hoisted_20), [
                                [_vModelText, _ctx.formData.employee_name]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.employee_name.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "\n              * " + _toDisplayString(_ctx.v$.formData.employee_name.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "name-input",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.employee_number) = $event)),
                                type: "text",
                                name: "employee-number",
                                autocomplete: "employee-number",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'error-border': _ctx.v$.formData.employee_number.$error,
                                        'border-red-500': _ctx.v$.formData.employee_number.$error,
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.employee_number.$touch()))
                            }, null, 42, _hoisted_24), [
                                [_vModelText, _ctx.formData.employee_number]
                            ]),
                            _createTextVNode(),
                            _hoisted_25,
                            _createTextVNode(),
                            (_ctx.v$.formData.employee_number.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "\n              * " + _toDisplayString(_ctx.v$.formData.employee_number.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_29, [
                                _withDirectives(_createElementVNode("select", {
                                    id: "division",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.formData.division) = $event)),
                                    name: "divison",
                                    autocomplete: "division-name",
                                    class: _normalizeClass(["max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md", {
                                            'error-border': _ctx.v$.formData.division.$error,
                                            'border-red-500': _ctx.v$.formData.division.$error,
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.division.$touch()))
                                }, [
                                    (_ctx.disableForm)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems.DIVISIONS, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.ID,
                                                value: item.NAME
                                            }, _toDisplayString(item.NAME), 9, _hoisted_31));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeDivisions, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.ID,
                                                value: item.NAME
                                            }, _toDisplayString(item.NAME), 9, _hoisted_32));
                                        }), 128))
                                ], 42, _hoisted_30), [
                                    [_vModelSelect, _ctx.formData.division]
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.division.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "\n              * " + _toDisplayString(_ctx.v$.formData.division.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_36, [
                                (!_ctx.disableForm)
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        id: "sector",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.formData.sector) = $event)),
                                        name: "sector",
                                        autocomplete: "sector-name",
                                        class: _normalizeClass(["max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md", {
                                                'error-border': _ctx.v$.formData.sector.$error,
                                                'border-red-500': _ctx.v$.formData.sector.$error,
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.sector.$touch()))
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSectors, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.ID,
                                                value: item.NAME
                                            }, _toDisplayString(item.NAME), 9, _hoisted_38));
                                        }), 128))
                                    ], 42, _hoisted_37)), [
                                        [_vModelSelect, _ctx.formData.sector]
                                    ])
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        id: "sector-name",
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.formData.sector) = $event)),
                                        disabled: "",
                                        type: "text",
                                        name: "sector-name",
                                        autocomplete: "sector-name",
                                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                                'bg-gray-200 border-none cursor-not-allowed text-gray-700': _ctx.disableForm,
                                            }]),
                                        onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.sector.$touch()))
                                    }, null, 34)), [
                                        [_vModelText, _ctx.formData.sector]
                                    ])
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.sector.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "\n              * " + _toDisplayString(_ctx.v$.formData.sector.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_42, [
                                _withDirectives(_createElementVNode("select", {
                                    id: "sector",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.formData.company_code) = $event)),
                                    name: "company_code",
                                    autocomplete: "company_code-name",
                                    class: _normalizeClass(["max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md", {
                                            'error-border': _ctx.v$.formData.company_code.$error,
                                            'border-red-500': _ctx.v$.formData.company_code.$error,
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.company_code.$touch()))
                                }, [
                                    (_ctx.disableForm)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems?.ENTITIES, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.entity,
                                                value: item.entity
                                            }, _toDisplayString(item.entity), 9, _hoisted_44));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeEntities, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.entity,
                                                value: item.entity
                                            }, _toDisplayString(item.entity), 9, _hoisted_45));
                                        }), 128))
                                ], 42, _hoisted_43), [
                                    [_vModelSelect, _ctx.formData.company_code]
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.company_code.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, "\n              * " + _toDisplayString(_ctx.v$.formData.company_code.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "personal-name",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.formData.personal_email) = $event)),
                                type: "text",
                                name: "personal-name",
                                autocomplete: "employee-name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                    }]),
                                disabled: _ctx.disableForm
                            }, null, 10, _hoisted_49), [
                                [_vModelText, _ctx.formData.personal_email]
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_50, [
                            _hoisted_51,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("select", {
                                    id: "location",
                                    name: "location",
                                    value: _ctx.formData.location,
                                    rows: "3",
                                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                            'error-border': _ctx.v$.formData.location.$error,
                                            'border-red-500': _ctx.v$.formData.location.$error,
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onChange: _cache[17] || (_cache[17] =
                                        //@ts-ignore
                                        (...args) => (_ctx.setLocation && _ctx.setLocation(...args))),
                                    onBlur: _cache[18] || (_cache[18] = ($event) => (_ctx.v$.formData.location.$touch()))
                                }, [
                                    (_ctx.disableForm)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems.LOCATIONS, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.LOCATIONCODE,
                                                value: item.LOCATIONLOOKUP
                                            }, _toDisplayString(item.DISPLAYNAME), 9, _hoisted_54));
                                        }), 128))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeLocations, (item) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: item.LOCATIONCODE,
                                                value: item.LOCATIONLOOKUP
                                            }, _toDisplayString(item.DISPLAYNAME), 9, _hoisted_55));
                                        }), 128))
                                ], 42, _hoisted_53)
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.location.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, "\n              * " + _toDisplayString(_ctx.v$.formData.location.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_57, [
                            _hoisted_58,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "name-input",
                                value: _ctx.formData.location_postcode,
                                type: "text",
                                name: "location-postcode",
                                autocomplete: "location-postcode",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                disabled: ""
                            }, null, 8, _hoisted_59)
                        ])
                    ]),
                    _createTextVNode(),
                    _hoisted_60
                ]),
                _createTextVNode(),
                (!_ctx.disableForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("button", {
                            disabled: _ctx.v$.$invalid,
                            type: "submit",
                            class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                        }, "\n          Save\n        ", 8, _hoisted_62)
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]))
        : _createCommentVNode("", true);
}
